import {faChevronDown} from '@fortawesome/pro-light-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import React, {
  useState,
  useRef,
} from 'react';
import styled from 'styled-components';
import {useStore} from '@/store/root-store';
import {TargetKeywords} from './TargetKeywords/TargetKeywords';
import styles from './style.module.scss';
import classNames from 'classnames';
import {KeywordSuggestions} from './KeywordSuggestions/KeywordSuggestions';
import {observer} from 'mobx-react';
import {
  Tooltip,
} from 'antd';
import {
  faChevronsDown,
  faChevronUp,
} from '@fortawesome/pro-regular-svg-icons';

interface Props {
  updateKeywordsRef: () => void;
}

export const TargetKeywordsAndSuggestions = observer(({updateKeywordsRef}: Props) => {
  const [isExpanded, setIsExpanded] = useState<'collapsed' | 'expanded' | 'fullExpanded'>('expanded');

  const containerRef = useRef(null);

  const {contentOptimizer: {currentPage}} = useStore('');
  const {settings: {customer: {getCustomerQuota, profile: {quotaUtilization}}}, plans: {showSidebarPaymentDrawer}} = useStore('');


  return <div className={styles.expandingContainer} style={{maxHeight: (isExpanded == 'fullExpanded' || currentPage?.isExportingPage) ? '500px' : isExpanded == 'collapsed' ? '0px' : '157px'}}>
    <div className={classNames(styles.keywordsAndSuggestionsContainer, (isExpanded == 'fullExpanded' || currentPage?.isExportingPage) && styles.expanded, isExpanded == 'collapsed' && styles.collapsed)} ref={containerRef}>
      <div className={classNames(styles.targetKeywordsSectionContainer, (isExpanded == 'fullExpanded' || currentPage?.isExportingPage) && styles.expanded)} style={{width: currentPage?.isExportingPage && '100%'}}>
        <div className={classNames(styles.targetKeywordsContainer, (isExpanded == 'fullExpanded' || currentPage?.isExportingPage) && styles.expanded, isExpanded == 'collapsed' && styles.collapsed)}>

          <TargetKeywords
            parentRef={containerRef}
            expanded={isExpanded == 'fullExpanded'}
            getCustomerQuota={getCustomerQuota}
            showSidebarPaymentDrawer={showSidebarPaymentDrawer} />
        </div>
      </div>

      <div className={classNames(styles.kwSuggestionsContainer, isExpanded == 'fullExpanded' && styles.expanded)} style={{display: currentPage?.isExportingPage ? 'none' : 'block'}}>

        <KeywordSuggestions
          store={currentPage}
          getCustomerQuota={getCustomerQuota}
          showSidebarPaymentDrawer={showSidebarPaymentDrawer}
          quotaUtilization={quotaUtilization} />
      </div>
    </div>
    {isExpanded == 'collapsed' && <Tooltip placement='top' title={'Show Keywords'}>
      <div
        className={styles.expandBtn}
        style={{
          height: 28,
          paddingTop: 1,
        }}
        onClick={() => {
          setIsExpanded('expanded');
          setTimeout(() => {
            updateKeywordsRef();
          }, 300);
        }}>
        <ChevronDown icon={faChevronDown} className={styles.expandIcon} size='lg' />
      </div>
    </Tooltip>}
    {isExpanded != 'collapsed' && <Tooltip placement='bottom' title={isExpanded == 'fullExpanded' ? 'Collapse Keywords' : 'Expand Keywords'}>
      <div
        className={styles.expandBtn}
        onClick={() => {
          setIsExpanded(isExpanded == 'fullExpanded' ? 'collapsed' : 'fullExpanded');
          setTimeout(() => {
            updateKeywordsRef();
          }, 300);
        }}>
        {isExpanded == 'expanded' && <ChevronDown icon={faChevronsDown} className={styles.expandIcon} size='lg' />}
        {isExpanded == 'fullExpanded' && <ChevronDown icon={faChevronUp} className={styles.expandIcon} size='lg' />}
      </div>
    </Tooltip>}
  </div>;
});

const ChevronDown = styled(FontAwesomeIcon) <{ }>`
  transition: all 0.3s ease;
  font-size: 14px;
`;

